import {
  GET_GOOD_SERVICES_HEAD_MASTER_LIST,
  GET_GOOD_SERVICES_HEAD_MASTER_LIST_SUCCESS,
  GET_GOOD_SERVICES_HEAD_MASTER_LIST_FAIL,
  GET_GOOD_SERVICES_HEAD_MASTER_DETAIL,
  GET_GOOD_SERVICES_HEAD_MASTER_DETAIL_SUCCESS,
  GET_GOOD_SERVICES_HEAD_MASTER_DETAIL_FAIL,
  ADD_NEW_GOOD_SERVICES_HEAD_MASTER,
  ADD_NEW_GOOD_SERVICES_HEAD_MASTER_SUCCESS,
  ADD_NEW_GOOD_SERVICES_HEAD_MASTER_FAIL,
  UPDATE_GOOD_SERVICES_HEAD_MASTER,
  UPDATE_GOOD_SERVICES_HEAD_MASTER_SUCCESS,
  UPDATE_GOOD_SERVICES_HEAD_MASTER_FAIL,
  DELETE_GOOD_SERVICES_HEAD_MASTER,
  DELETE_GOOD_SERVICES_HEAD_MASTER_SUCCESS,
  DELETE_GOOD_SERVICES_HEAD_MASTER_FAIL,
} from "./actionTypes"

export const getGoodServicesHeadMasterList = () => ({
  type: GET_GOOD_SERVICES_HEAD_MASTER_LIST,
})

export const getGoodServicesHeadMasterListSuccess = goodServicesHeads => ({
  type: GET_GOOD_SERVICES_HEAD_MASTER_LIST_SUCCESS,
  payload: goodServicesHeads,
})
export const getGoodServicesHeadMasterListFail = error => ({
  type: GET_GOOD_SERVICES_HEAD_MASTER_LIST_FAIL,
  payload: error,
})

export const getGoodServicesHeadMasterDetail = goodServicesHeadId => ({
  type: GET_GOOD_SERVICES_HEAD_MASTER_DETAIL,
  goodServicesHeadId,
})

export const getGoodServicesHeadMasterDetailSuccess = goodServicesHeadDetail => ({
  type: GET_GOOD_SERVICES_HEAD_MASTER_DETAIL_SUCCESS,
  payload: goodServicesHeadDetail,
})

export const getGoodServicesHeadMasterDetailFail = error => ({
  type: GET_GOOD_SERVICES_HEAD_MASTER_DETAIL_FAIL,
  payload: error,
})

export const addNewGoodServicesHeadMaster = (goodServicesHead, history) => ({
  type: ADD_NEW_GOOD_SERVICES_HEAD_MASTER,
  payload: { goodServicesHead, history },
  status: true,
})

export const addNewGoodServicesHeadMasterSuccess = goodServicesHead => ({
  type: ADD_NEW_GOOD_SERVICES_HEAD_MASTER_SUCCESS,
  payload: goodServicesHead,
})

export const addNewGoodServicesHeadMasterFail = error => ({
  type: ADD_NEW_GOOD_SERVICES_HEAD_MASTER_FAIL,
  payload: error,
})

export const updateGoodServicesHeadMaster = (id, goodServicesHead, history) => ({
  type: UPDATE_GOOD_SERVICES_HEAD_MASTER,
  payload: { id, goodServicesHead, history },
})

export const updateGoodServicesHeadMasterSuccess = goodServicesHead => ({
  type: UPDATE_GOOD_SERVICES_HEAD_MASTER_SUCCESS,
  payload: goodServicesHead,
})

export const updateGoodServicesHeadMasterFail = error => ({
  type: UPDATE_GOOD_SERVICES_HEAD_MASTER_FAIL,
  payload: error,
})

export const deleteGoodServicesHeadMaster = goodServicesHead => ({
  type: DELETE_GOOD_SERVICES_HEAD_MASTER,
  payload: goodServicesHead,
})

export const deleteGoodServicesHeadMasterSuccess = goodServicesHead => ({
  type: DELETE_GOOD_SERVICES_HEAD_MASTER_SUCCESS,
  payload: goodServicesHead,
})

export const deleteGoodServicesHeadMasterFail = error => ({
  type: DELETE_GOOD_SERVICES_HEAD_MASTER_FAIL,
  payload: error,
})
